import {Component} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {
  DashBlockCommercialComponent
} from "../../../components/user/dash-block/dash-block-commercial/dash-block-commercial.component";
import {CancelButtonComponent} from "../../../components/common/cancel-button/cancel-button.component";

@Component({
    selector: 'app-ticket-commerce-modal',
    imports: [
    DashBlockCommercialComponent,
    CancelButtonComponent
],
    templateUrl: './ticket-commerce-modal.component.html',
    styleUrl: './ticket-commerce-modal.component.scss'
})
export class TicketCommerceModalComponent {

  constructor(public activeModal: NgbActiveModal) {
  }

}
